export default "__VITE_ASSET__6c2aaf99__"